import { useEffect, useState } from "react";
import { setInventory } from "@/lib/inventory";
import { LogoImg } from "@/components/layout/Logo";

const API = process.env.REACT_APP_BACKEND_URL;

// Loads live AutoTrader stock before rendering; falls back to the bundled snapshot.
export const InventoryGate = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    let cancelled = false;
    const timer = setTimeout(() => ctrl.abort(), 5000);
    const load = async () => {
      try {
        if (!API) return;
        const res = await fetch(`${API}/api/vehicles`, { signal: ctrl.signal });
        const json = await res.json();
        if (res.ok && Array.isArray(json?.vehicles)) setInventory(json.vehicles, json?.lastSynced);
      } catch (e) {
        // keep bundled snapshot
      } finally {
        clearTimeout(timer);
        if (!cancelled) setReady(true);
      }
    };
    load();
    return () => {
      cancelled = true;
      clearTimeout(timer);
      ctrl.abort();
    };
  }, []);

  if (!ready)
    return (
      <div className="flex min-h-screen items-center justify-center bg-white" data-testid="inventory-loading">
        <LogoImg className="h-8 animate-pulse" />
      </div>
    );
  return children;
};
